import {
  isRequired,
  isEmail,
  isValidLength,
  isValidExpirationDate,
  isNumber
} from 'utils/validators';

const CREDIT_CARD_AMOUNT_SYMBOLS = 18;
const EXPIRATION_DATE_AMOUNT_SYMBOLS = 4;
const CVV_AMOUNT_SYMBOLS = 2;

const validate = values => {
  const errors = {};

  if (isRequired(values.firstName || '', true)) {
    errors.firstName = 'First name is required';
  }

  if (isRequired(values.lastName || '', true)) {
    errors.lastName = 'Last name is required';
  }

  if (isRequired(values.phone || '', true)) {
    errors.phone = 'Phone is required';
  }

  if (isRequired(values.email || '', true)) {
    errors.email = 'Email is required';
  } else if (isEmail(values.email || '', true)) {
    errors.email = 'Invalid email';
  }

  if (isRequired(values.address || '', true)) {
    errors.address = 'Address is required';
  }

  if (isRequired(values.city || '', true)) {
    errors.city = 'City is required';
  }

  if (isRequired(values.zip || '', true)) {
    errors.zip = 'Zip is required';
  }

  if (isRequired(values.creditCard || '', true)) {
    errors.creditCard = 'Credit card is required';
  } else if (
    !isValidLength(values.creditCard, CREDIT_CARD_AMOUNT_SYMBOLS, true)
  ) {
    errors.creditCard = 'Invalid credit card';
  }

  if (isRequired(values.expirationDate || '', true)) {
    errors.expirationDate = 'Expiration date is required';
  } else if (
    !isValidLength(values.expirationDate, EXPIRATION_DATE_AMOUNT_SYMBOLS, true)
  ) {
    errors.expirationDate = 'Invalid expiration date';
  } else if (!isValidExpirationDate(values.expirationDate)) {
    errors.expirationDate = 'Invalid expiration date';
  }

  if (isNumber(values.cvv || '', true)) {
    errors.cvv = 'Cvv is required';
  } else if (!isValidLength(values.cvv, CVV_AMOUNT_SYMBOLS, true)) {
    errors.cvv = 'Invalid CVV';
  }

  return errors;
};

export default validate;
